// client/src/pages/authentication/NewUnifiedLogin.tsx
import { FC } from "react";
import { Box, Button, Card } from "@mui/material";
import axiosInstance from "../../utils/axios";
import toast from "react-hot-toast";
import FlexBox from "../../components/FlexBox";
import { H1 } from "../../components/Typography";

const NewUnifiedLogin: FC = () => {
  const handleLogin = async () => {
    try {
      // Ask backend for Google auth URL
      const res = await axiosInstance.get("/google/auth-url");
      const url = res.data?.url;

      if (!url) {
        toast.error("Failed to get Google login URL");
        return;
      }

      // Redirect browser to Google's consent screen
      window.location.href = url;
    } catch (err) {
      console.error(err);
      toast.error("Failed to start Google login");
    }
  };

  return (
    <FlexBox
      sx={{
        alignItems: "center",
        flexDirection: "column",
        justifyContent: "center",
        height: { sm: "100%" },
      }}
    >
      <Card sx={{ padding: 4, maxWidth: 600, boxShadow: 1 }}>
        <FlexBox
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
          mb={5}
        >
          <Box width={38} mb={1}>
            <img
              src="https://res.cloudinary.com/tamarayul/image/upload/v1658759981/react-links-project/su0qe8ezrol92veq8d8g.svg"
              width="100%"
              alt="CS-App Logo"
            />
          </Box>
          <H1 fontSize={24} fontWeight={700}>
            Sign in to CS-App
          </H1>
        </FlexBox>

        <FlexBox
          alignItems="center"
          flexDirection="column"
          justifyContent="center"
        >
          <Box sx={{ mt: 4 }}>
            <Button
              style={{ backgroundColor: "#3448c5" }}
              variant="contained"
              size="small"
              onClick={handleLogin}
            >
              Sign in with Google 🚀
            </Button>
          </Box>
        </FlexBox>
      </Card>
    </FlexBox>
  );
};

export default NewUnifiedLogin;